import { gql } from "@apollo/client";

export const CRM_SEQUENCE_TEMPLATES = gql`
  query CrmSequenceTemplates($where: CrmSequenceTemplateWhereInput, $take: Int, $skip: Int) {
    crmSequenceTemplates(where: $where, take: $take, skip: $skip) {
      data {
        id
        name
        description
        category
        channelMix
        stepCount
        estimatedDurationDays
        sequenceId
        usageCount
        createdDate
        updatedDate
      }
      count
    }
  }
`;

const crmTemplates = { CRM_SEQUENCE_TEMPLATES };
export default crmTemplates;
